import { useQuery, UseQueryOptions } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getSingleStudyDetailUrl } from "@src/config/baseUrls";
import { queryKeys } from "@src/config/queryKeys";
import { StudyDetail } from "@src/modules/shared/types";

interface SingleStudyDetail extends StudyDetail {
  phantomCode: number;
  phantomName: string;
  hasImagesRangeSelection: boolean;
}

const useSingleStudyDetail = (
  studyId: string,
  options?: UseQueryOptions<SingleStudyDetail>,
) => {
  const axios = useAxios();

  return useQuery<SingleStudyDetail>(
    [queryKeys.SINGLE_STUDY_DETAIL, studyId],
    async () => {
      const { data } = await axios.get(getSingleStudyDetailUrl(studyId));
      return data;
    },
    options,
  );
};

export default useSingleStudyDetail;
